import {apiActionsBillingGroups} from "../constants/ApiMiddlewareConstants";
import API from "../../../common/utils/API";
import {
    fetchAllBillingGroups,
    getAllBillingGroupsSuccess,
    fetchBillingGroupDetailSuccess
} from "../../../veritas/billing-groups/actions/BillingGroupActions";
import {activityLoggerActionTypes} from "../constants/UtilityMiddlewareConstants";
import {toggleBillingGroupModal, updatedBillingGroupRefresh} from "../../../veritas/add-edit/actions/AddEditBillingGroupActions";
import {selectBillingGroup} from "../../../veritas/add-edit/actions/AddEditDPServiceActions";
import {toUpperCaseSentence} from "../../../common/utils/ToUpperCaseSentence";
import {displayDuplicateMessage, displayErrorMessage} from "../../../common/marvel-reducers/formMessageActions";
import MARVEL from "../../../common/utils/MarvelUrls";
import { setRouterLink } from "../../../router/RouterActions";
/**
 * This is the Middleware to handle the API calls pertaining to
 * Billing Groups. (Currently, only contains logic for get all
 * ... rest will be added subsequently.)
 * @param store, action
 * @returns Makes the API call and conditionally dispatches logger actions or
 * error or warning messages.
 */
const apiMiddlewareBillingGroups = (store) => (next) => (action) => {

    switch (action.type) {

        case apiActionsBillingGroups.GET_ALL_BILLING_GROUPS: {
            next(action);

            const {authToken} = action.payload;
            API.getAllBillingGroups(authToken.idToken)
                .then(res => {
                    store.dispatch(getAllBillingGroupsSuccess(res.data))
                })
                .catch(error => {
                    console.error(error);
                    throw error;
                })
            break;
        }

        case apiActionsBillingGroups.GET: {
            next(action);

            const {billingGroupID, authToken} = action.payload;
            API.getOneBillingGroup(billingGroupID, authToken.idToken)
                .then(res => {
                    store.dispatch(fetchBillingGroupDetailSuccess(res.data))
                })
                .catch(error => {
                    console.error(error);
                })

            break;
        }

        case apiActionsBillingGroups.PUT:{
            next(action);

            const { billingGroupID, billingGroupObj, authToken } = action.payload;
            if (authToken.account.name) {
                billingGroupObj.updated_by = authToken.account.name;
            }
            API.putOneBillingGroup(billingGroupID, billingGroupObj, authToken.idToken)
                .then(res => {
                    const log = {
                        object_id: res.data.id,
                        object_type: "billing_group_edit",
                        user: authToken.account.name
                    };
                    store.dispatch({
                        type: activityLoggerActionTypes.LOG_CHANGE,
                        payload: { log, authToken }
                    });
                    store.dispatch(toggleBillingGroupModal());
                    store.dispatch(updatedBillingGroupRefresh());
                })
                .catch(error => {
                    const message = [];
                    const errorObj = error.response.data
                    // pretty print the error message for the user
                    // eslint-disable-next-line no-unused-vars
                    for (let [value] of Object.entries(errorObj)) {
                        message.push(toUpperCaseSentence(value[0]));
                    }
                    store.dispatch(displayErrorMessage(message, true));
                })

            break;
        }

        case apiActionsBillingGroups.POST:{
            next(action);

            const { billingGroupObj, formSource, authToken } = action.payload;
            if (authToken.account.name) {
                billingGroupObj.updated_by = authToken.account.name;
            }
            API.postOneBillingGroup(billingGroupObj, authToken.idToken)
                .then(res => {
                    const log = {
                        object_id: res.data.id,
                        object_type: "billing_group_create",
                        user: authToken.account.name
                    };
                    const bg = {
                        id: res.data.id,
                        billing_group_name: res.data.billing_group_name
                    }
                    const change_obj = {
                        action: 'select-option',
                        name: 'billing_group'
                    }
                    store.dispatch({
                        type: activityLoggerActionTypes.LOG_CHANGE,
                        payload: { log, authToken }
                    });
                    store.dispatch(fetchAllBillingGroups());
                    if ( formSource && formSource === 'DPServicesForm') {
                        store.dispatch(selectBillingGroup(bg, change_obj));
                    } else {
                        store.dispatch(toggleBillingGroupModal());
                    }
                })
                .catch(error => {
                    const errorObj = error.response.data
                    const message = [];
                    // pretty print the error message for the user
                    // eslint-disable-next-line no-unused-vars
                    for (let [value] of Object.entries(errorObj)) {
                        message.push(toUpperCaseSentence(value));
                    }
                    if (errorObj['billing_group_name']) {
                        store.dispatch(displayDuplicateMessage(message, true));
                    } else {
                        store.dispatch(displayErrorMessage(message, true));
                    }
                });

            break;
        }

        case apiActionsBillingGroups.DELETE: {
            next(action);

            const {billingGroupID, authToken} = action.payload;
            API.deleteOneBillingGroup(billingGroupID, authToken.idToken)
                .then(res => {
                    const log = {
                        object_id: billingGroupID,
                        object_type: "billing_group_delete",
                        user: authToken.account.name
                    };
                    store.dispatch({
                        type: activityLoggerActionTypes.LOG_CHANGE,
                        payload: {log, authToken}
                    });
                    store.dispatch(fetchAllBillingGroups())
                    store.dispatch(setRouterLink(MARVEL.VERITAS.billing_groups))

                })
                .catch(error => {
                    console.error(error);
                })

            break;
        }

        default: next(action);
    }
}

export default apiMiddlewareBillingGroups;
